import * as EventsConstants from '../constants/events-constants';
import API from '../api/events-api';

const fetchAllEventsBegin = () => {
    return {
        type: EventsConstants.FETCH_ALL_EVENTS_BEGIN
    }
}

const fetchAllEventsSuccess = (data) => {
    return {
        type: EventsConstants.FETCH_ALL_EVENTS_SUCCESS,
        data
    }
}

const fetchAllEventsError = (error) => {
    return {
        type: EventsConstants.FETCH_ALL_EVENTS_FAILURE,
        error
    }
}

export const getAllEvents = (sort = undefined) => (dispatch) => {
    dispatch(fetchAllEventsBegin());
    API.getAllEvents(sort)
        .then((response) => {
            if (response.data.errorMessage) {
                dispatch(fetchAllEventsError(response.data));
            }
            if (response.data.events) {
                dispatch(fetchAllEventsSuccess(response.data.events));
                dispatch(getRecurrentEvents());
            }
        })
        .catch((err) => {
            dispatch(fetchAllEventsError(err));
        });
}

const getRecurrentEventsBegin = () => {
    return {
        type: EventsConstants.FETCH_RECURRENT_EVENTS_BEGIN
    }
}

const getRecurrentEventsSuccess = (data) => {
    return {
        type: EventsConstants.FETCH_RECURRENT_EVENTS_SUCCESS,
        data
    }
}

const getRecurrentEventsError = (error) => {
    return {
        type: EventsConstants.FETCH_RECURRENT_EVENTS_FAILURE,
        error
    }
}

export const getRecurrentEvents = () => (dispatch) => {
    dispatch(getRecurrentEventsBegin());
    API.getAllEvents('recurrentEvents')
        .then((response) => {
            if (response.data.errorMessage) {
                dispatch(getRecurrentEventsError(response.data));
            }
            if (response.data.events) {
                dispatch(getRecurrentEventsSuccess(response.data.events));
                dispatch(getForecasts())
            }
        })
        .catch((err) => {
            dispatch(getRecurrentEventsError(err));
        });
}

const getForecastsBegin = () => {
    return {
        type: EventsConstants.FETCH_FORECASTS_BEGIN
    }
}

const getForecastsSuccess = (foreCast) => {
    return {
        type: EventsConstants.FETCH_FORECASTS_SUCCESS,
        foreCast
    }
}

const getForecastsError = (error) => {
    return {
        type: EventsConstants.FETCH_FORECASTS_FAILURE,
        error
    }
}

const getForecasts = () => (dispatch) => {
    const up = JSON.parse(localStorage.getItem('userProfile'));
    dispatch(getForecastsBegin());
    if (up.weather && up.weather.length) {
        const activeForecasts = up.weather.filter(wF => wF.active === true);
        if (activeForecasts.length > 0) {
            const activeForecasts = up.weather.filter(wF => wF.active === true);
            activeForecasts.forEach(element => {
                API.getWeatherByLocation(element.name)
                    .then((wResponse) => {
                        if (wResponse.data.foreCast) {
                            dispatch(getForecastsSuccess(wResponse.data.foreCast))
                        } else {
                            dispatch(getForecastsSuccess('empty'))
                        }
                    })
                    .catch((err) => {
                        dispatch(getForecastsError(err))
                    });
            });
        } else {
            dispatch(getForecastsSuccess('empty'))
        }
    } else {
        dispatch(getForecastsSuccess('empty'))
    }
}

const createEventBegin = () => {
    return {
        type: EventsConstants.CREATE_EVENT_BEGIN
    }
}

const createEventSuccess = (data) => {
    return {
        type: EventsConstants.CREATE_EVENT_SUCCESS,
        data
    }
}

const createEventError = (error) => {
    return {
        type: EventsConstants.CREATE_EVENT_FAILURE,
        error
    }
}

/**
 * @param {Object} data - data Object.
 * @param {string} data.sortKey - MMMM-YY.
 * @param {string} data.email - User email.
 * @param {Array} data.events - Events
 * @param {Boolean} data.create - Should create only
 * @param {string} data.viewSortKey - The sort key for the current month view
 */
export const createEvent = (data) => (dispatch) => {
    dispatch(createEventBegin());
    API.putEvents(data)
        .then((response) => {
            if (response.data.errorMessage) {
                dispatch(createEventError(response.data));
            }
            if (response.data.events) {
                dispatch(createEventSuccess(response.data.events));
                dispatch(getRecurrentEvents());
            }
        })
        .catch((err) => {
            dispatch(createEventError(err));
        });
}

const deleteEventBegin = () => {
    return {
        type: EventsConstants.DELETE_EVENT_BEGIN
    }
}

const deleteEventSuccess = (data, eventType) => {
    return {
        type: EventsConstants.DELETE_EVENT_SUCCESS,
        data,
        eventType
    }
}

const deleteEventError = (error) => {
    return {
        type: EventsConstants.DELETE_EVENT_FAILURE,
        error
    }
}

/**
 * @param {Object} data - data Object.
 * @param {string} data.sortKey - MMMM-YY.
 * @param {string} data.email - User email.
 * @param {Array} data.events - Events
 * @param {Boolean} data.create - Should create only
 */
export const deleteEvent = (data, eventType = 'event') => (dispatch) => {
    dispatch(deleteEventBegin());
    API.putEvents(data)
        .then((response) => {
            if (response.data.errorMessage) {
                dispatch(deleteEventError(response.data));
            }
            if (response.data.events) {
                dispatch(deleteEventSuccess(response.data.events, eventType));
                dispatch(getRecurrentEvents());
            }
        })
        .catch((err) => {
            dispatch(deleteEventError(err));
        });
}

const renderBegin = () => {
    return {
        type: EventsConstants.RENDER_BEGIN
    }
}

export const renderLoading = () => (dispatch) =>{
    dispatch(renderBegin());
}


const renderSuccess = () => {
    return {
        type: EventsConstants.RENDER_SUCCESS
    }
}

export const renderDone = () => (dispatch) =>{
    dispatch(renderSuccess());
}